<template>
  <div>
    <PageAllow controller="CloudPrints" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet
        v-show="!currentItemMode"
        class="transparent-background-color fill-content-height"
      >
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="keyword = $event"
                :label="$t('cloudPrinterSetting.Fields.keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                  }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('CloudPrints', 'edit')"
                small
                color="primary"
                @click.stop="settingDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("cloudPrinterSetting.settingBtn") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('CloudPrints', 'add')"
                small
                color="primary"
                @click.stop="ImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("cloudPrinterSetting.import") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('CloudPrints', 'add')"
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("cloudPrinterSetting.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 my-4">
          <v-data-table
            :headers="headers"
            :items="cloudPrints"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.type="{ item }">
              {{ item.type == 0 ? $t("cloudPrinterSetting.type.default") : $t("cloudPrinterSetting.type.label") }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.viewInfo", [$t("cloudPrinterSetting.ObjectName")]) }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.editInfo", [$t("cloudPrinterSetting.ObjectName")]) }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.deleteInfo", [$t("cloudPrinterSetting.ObjectName")]) }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item.max_str="{ item }">
              {{ item.max_str | cloudPrinterMaxStrText }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <SettingDialog
      v-model="settingDialog"
      :user="feieUser"
      :ukey="feieUkey"
      @save="getSettingsFromAPI()"
    />

    <CloudPrintDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      :stocks="stocks"
      @mode="currentItemMode = $event"
      @save="getCloudPrintsFromAPI()"
    />

    <DialogDelete
      v-model="deleteDialog"
      :label="$t('cloudPrinterSetting.ObjectName')"
      @confirm="
        deleteCloudPrinter();
        deleteDialog = false;
      "
    />

    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('cloudPrinterSetting.ObjectName')"
      downloadTemplateUrl="download/template/cloud_printer_template.xlsx"
      @import="
        excelFile = $event;
        importExcel();
      "
    />

    <ImportResult
      v-model="importResultFlg"
      :errorData="importResults"
     @input="getCloudPrintsFromAPI();"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import CloudPrintDetail from "./plugins/Detail";
import SettingDialog from "./plugins/SettingDialog";
import ImportResult from "./plugins/importResult";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import DialogDelete from "@/components/plugins/DialogDelete";
import CloudPrints from "@/api/cloud_prints";

const defaultOptions = {
  keyword: "",
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    CloudPrintDetail,
    DialogDelete,
    SearcherKeyword,
    SettingDialog,
    ImportExcelAlert,
    ImportResult,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.printSetting"),
        disabled: false,
        href: "/settings/print-templates",
      },
      {
        text: i18n.t("SettingNav.cloudPrinterSetting"),
        disabled: true,
      },
    ],

    headers: () => [
      {
        text: i18n.t("cloudPrinterSetting.Fields.type"),
        align: "start",
        sortable: false,
        value: "type",
      },
      {
        text: i18n.t("cloudPrinterSetting.Fields.sn"),
        align: "start",
        sortable: false,
        value: "sn",
      },
      {
        text: i18n.t("cloudPrinterSetting.Fields.key"),
        align: "start",
        sortable: false,
        value: "printer_key",
      },
      {
        text: i18n.t("cloudPrinterSetting.Fields.max_str"),
        align: "start",
        sortable: false,
        value: "max_str",
      },
      {
        text: i18n.t("cloudPrinterSetting.Fields.remark"),
        align: "start",
        sortable: false,
        value: "remark",
      },
      {
        text: i18n.t("cloudPrinterSetting.Fields.carnum"),
        align: "start",
        sortable: false,
        value: "carnum",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    keyword: "",
    paging: {},
    cloudPrints: [],
    settingDialog: false,
    deleteDialog: false,
    ImportDialog: false,
    currentItem: null,
    currentItemMode: null,
    feieUser: null,
    feieUkey: null,
    excelFile: null,
    importResultFlg: false,
    importResults: null,
    stocks: []
  }),

  mounted() {
    this.getSettingsFromAPI();
    this.getCloudPrintsFromAPI();
  },

  methods: {
    getSettingsFromAPI() {
      CloudPrints.getSetting().then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.setting) {
              this.feieUser = response.data.setting.user;
              this.feieUkey = response.data.setting.ukey;
            }
          }
        }.bind(this)
      );
    },
    getCloudPrintsFromAPI() {
      CloudPrints.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.cloudPrints = response.data.cloud_prints;
            this.stocks = response.data.stocks;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    deleteCloudPrinter() {
      if (this.currentItem)
        CloudPrints.del(this.currentItem).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getCloudPrintsFromAPI(); // 删除成功的话刷新数据
            }
          }.bind(this)
        );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      CloudPrints.imports(this.excelFile).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.error && response.data.error.length) {
              this.ImportDialog = false;
              this.importResultFlg = true;
              this.importResults = response.data.error;
            } else {
              this.$snackbar.info(i18n.t("Import.success", [i18n.t("Dish.ObjectName")]));
              this.ImportDialog = false;
              this.getCloudPrintsFromAPI();
            }
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace(
            "/settings/cloud-printer-setting?id=" + this.currentItem.id
          );
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/settings/cloud-printer-setting");
        }
      },
    },
    currentItemMode: {
      handler() {
        this.getCloudPrintsFromAPI()
      }
    },

    options: {
      deep: true,
      handler() {
        this.getCloudPrintsFromAPI();
      },
    },
  },
};
</script>